module.exports = __webpack_public_path__ + "media/images/events-bg-b54887335133cba51a8482b1eddbda44.svg";